import React, { useEffect, useState } from "react";
import Footer from "../components/footer";
import HeaderTwo from "../components/header2";
import styles from "../styles/storys.module.css";
import { ReactComponent as RightChevronSvg } from '../svg/chevron-right-thin.svg';
import { ReactComponent as HouseSvg } from '../svg/house-thin.svg';

import { Link } from "react-router-dom";

import ReactGa from "react-ga4";

import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';



const MealMenu: React.FC<any> = (props) => {

    const [pageCount, setPageCount] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [data, setData] = useState<any>();
    const [totalCount, setTotalCount] = useState();

    useEffect(() => {
        window.scrollTo(0, 0);
    });

    const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
        setCurrentPage(value);
        window.location.assign("/mealmenu#" + value);
    };

    //ga event------------------------------------------------
    useEffect(() => {

        ReactGa.send({
            hitType: "pageview",
            page_title: "mealmenu"
        });

    }, []);
    //--------------------------------------------------------

    useEffect(() => {

        console.log(window.location.hash);

        if (window.location.hash) {
            const hash = window.location.hash;
            const newPageNumber = hash.split("#")[1];
            setCurrentPage(+newPageNumber);
        }

        fetch(`https://suneungsunbae.com/api/text/mealmenu?page=${currentPage}`, {
            method: "get"
        }).then((response: any) => {
            response.json()
                .then((result: any) => {
                    console.log(result);
                    if (result.message === "success") {
                        setData(result.data);
                        setTotalCount(result.count);
                        const count = result.count;
                        const pageCountVar = Math.floor(count / 20) + 1;
                        setPageCount(pageCountVar);
                    }
                })
        })

    }, [currentPage]);

    return (
        <div className={styles.main}>
            <HeaderTwo />
            <div className={styles.voidHeader}>
            </div>
            <div className={`${styles.headerBar} ${styles.onlyPC}`}
                style={{ backgroundImage: "url(img/faq.webp)" }}
            >
                수능선배 식단표
            </div>
            <div className={`${styles.currentMenuViewerDiv} ${styles.onlyPC}`}>
                <div className={styles.currentMenuViewer}>
                    <HouseSvg className={styles.houseSvg} />
                    <RightChevronSvg className={styles.rightChevron} />
                    <div className={styles.currentMenuViewerText_2}>
                        수능선배 식단표
                    </div>
                </div>
            </div>
            <div className={`${styles.currentMenuViewerBoarder} ${styles.onlyPC}`}>
            </div>

            <div className={`${styles.titleText} ${styles.onlyPC}`}>
                수능선배의<br></br>자세한 이야기를 들려드릴게요
            </div>



            <div className={styles.mobileTitleBox}>
                <div className={`${styles.mobileTitleText} ${styles.onlymobile}`}>
                    수능선배 식단표
                </div>
                <div className={`${styles.mobileSubTitleText} ${styles.onlymobile}`}>
                    수능선배의 자세한 이야기를 들려드릴게요
                </div>
            </div>

            {/* <div className={`${styles.mobileFeedBoxTitle} ${styles.onlymobile}`}>
                이야기 모음
            </div> */}

            <div className={styles.feedBox}>

                {
                    data && data.map((eachData: any) => {

                        const date = new Date(eachData.createdAt);

                        return (
                            <Link to={`/storyread?id=${eachData.id}`} style={{ textDecoration: "none", color: "inherit", width: "100%", display: "block" }}>
                                <div key={eachData.id} className={styles.eachFeedBox}>
                                    <div className={styles.eachFeedTextBox}>
                                        <div className={styles.eachFeedTextBoxCategory}>
                                            수능선배 식단표
                                        </div>
                                        <div className={styles.eachFeedTextBoxTitle}>
                                            {eachData && eachData.title}
                                        </div>
                                        {/* <div className={`${styles.eachFeedTextBoxSubTitle}`}>
                                            {eachData && eachData.subTitle}
                                        </div> */}
                                        <div className={styles.eachFeedTextBoxDate}>
                                            {date.getFullYear()}.{date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1}.{date.getDate() < 10 ? "0" + date.getDate() : date.getDate()}
                                        </div>
                                    </div>
                                    <div className={styles.eachFeedImgBox}>
                                        <div className={styles.imgWrapper}>
                                            <img className={styles.eachFeedImg} src={`${eachData.src}`} />
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        );
                    })
                }

            </div>


            <div className={`${styles.pagination} ${styles.onlyPC}`}>
                <Stack spacing={2}>
                    <Pagination count={pageCount} page={currentPage} onChange={handlePageChange} size="large" shape="rounded" />
                </Stack>
            </div>

            <div className={`${styles.pagination} ${styles.onlymobile}`}>
                <Stack spacing={2}>
                    <Pagination siblingCount={1} count={pageCount} page={currentPage} onChange={handlePageChange} size="medium" shape="rounded" />
                </Stack>
            </div>


            <Footer />
        </div>
    );
}

export default MealMenu;

